// extracted by mini-css-extract-plugin
export var button = "_k1-0";